// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav__jVsya","logo-wrapper":"logo-wrapper__3bw-F","logo":"logo__2Nr_j","icons":"icons__2IjVO","user-info":"user-info__1dwVe","profile":"profile__3VXcu","name":"name__2IY0v"};